module.exports = __webpack_public_path__ + "static/media/AST1207-Gateway-Alfa-Specification-V1.d17b8aee.pdf";